import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: () => import(/* webpackChunkName: "privacy" */ './views/Privacy.vue')
    },
    {
      path: '/activities',
      name: 'activities',
      component: () => import(/* webpackChunkName: "activities" */ './views/Activities.vue')
    },
    {
      path: '/activities/:slug',
      name: 'activity',
      component: () => import(/* webpackChunkName: "activity" */ './views/Activity.vue')
    },
    {
      path: '/resources/:slug',
      name: 'resource',
      component: () => import(/* webpackChunkName: "resource" */ './views/Resource.vue')
    },    
    {
      path: '/activity-groups/:slug',
      name: 'activity-group',
      component: () => import(/* webpackChunkName: "activity-group" */ './views/ActivityGroup.vue')
    },
    {
      path: '/events',
      name: 'events',
      component: () => import(/* webpackChunkName: "events" */ './views/Events.vue')
    },    
    {
      path: '/events/:slug',
      name: 'event',
      component: () => import(/* webpackChunkName: "event" */ './views/Event.vue')
    },
    {
      path: '/artworks',
      name: 'artworks',
      component: () => import(/* webpackChunkName: "events" */ './views/Artworks.vue')
    },    
    {
      path: '/artworks/:slug',
      name: 'artwork',
      component: () => import(/* webpackChunkName: "event" */ './views/Artwork.vue')
    },    
    {
      path: '/artworks/:slug/work',
      name: 'artwork-embed',
      component: () => import(/* webpackChunkName: "event" */ './views/ArtworkEmbed.vue')
    },      
    {
      path: '/about/:slug',
      name: 'person',
      component: () => import(/* webpackChunkName: "person" */ './views/Person.vue')
    },
    {
      path: '/tags/:slug',
      name: 'tag',
      component: () => import(/* webpackChunkName: "tag" */ './views/Tag.vue')
    }
  ]
})
